import React, { Component } from "react";
import * as s from "./NonHierarchicalDropdown.module.scss";
import { Icons } from "src/libs/assets";
import {
  P,
  Checkbox,
  Progressbar,
  SelectedTaxonomiesList
} from "src/views/shared/components";
import { observer } from "mobx-react";
import AnimateHeight from "react-animate-height";
import { tx } from "src/libs/i18n";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  dropdownTitle: string;
  largeOptions?: boolean;
  options?: any;
  toggleOption: any;
  open?: boolean;
  article?: boolean;
  showSelectedOptionsList?: boolean;
  search?: boolean;
}

interface State {
  open: boolean;
  expanded: boolean;
  searchTerm: string;
}

@observer
export class NonHierarchicalDropdown extends Component<Props, State> {
  state = {
    open: this.props.open ? true : false,
    expanded: false,
    searchTerm: ""
  };

  toggleOpen = () => {
    this.setState({
      open: !this.state.open,
      searchTerm: ""
    });
  };

  toggleExpand = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  };

  renderOption = (item, key) => {
    const { expanded } = this.state;
    const { largeOptions, options, toggleOption } = this.props;
    const { value, contributionPercentage, numberOfDocuments, selected } = item;

    let dropdownItemClasses = [s.dropdownItem];
    let labelClasses = [s.dropdownItemLabel];

    let formattedValue = value; //numberOfDocuments ? value + ` (${numberOfDocuments})` : value;

    if (key > 4 && !expanded) {
      dropdownItemClasses.push(s.hidden);
    }

    if (largeOptions) {
      labelClasses.push(s.largeLabel);
    }

    return (
      <div className={dropdownItemClasses.join(" ")} key={key}>
        <Checkbox
          type="check"
          onChange={() => toggleOption(options, item)}
          selected={selected}
          className={s.dropdownCheckbox}
        >
          <div className={s.labelContainer}>
            <P className={labelClasses.join(" ")}>{formattedValue}</P>
            {contributionPercentage > 0 && (
              <Progressbar percent={contributionPercentage} />
            )}
          </div>
        </Checkbox>
      </div>
    );
  };

  renderSelectedOptionsList = () => {
    const { options } = this.props;

    const selectedOptions = options?.filter(item => item.selected);

    if (selectedOptions?.length < 1) return null;

    return (
      <>
        <SelectedTaxonomiesList taxonomies={selectedOptions} />
        <div className={s.divider} />
      </>
    );
  };

  render() {
    const {
      className,
      dropdownTitle,
      options,
      article,
      showSelectedOptionsList,
      search
    } = this.props;
    const { open, expanded, searchTerm } = this.state;

    const filterDropdownClasses = [s.filterDropdown];
    const dropdownItemsClasses = [s.dropdownItems];
    let icon = Icons.chevronDown_large;

    const expandable = !!options && options.length > 4;
    const expandeableItems = expandable ? options.slice(5).length : 0;
    const hasSelected = options.find(opt => opt.selected);

    if (className) {
      filterDropdownClasses.push(className);
    }

    if (open || hasSelected) {
      filterDropdownClasses.push(s.open);
      icon = Icons.chevronUp_large;
    }

    if (expanded) {
      dropdownItemsClasses.push(s.expanded);
      if (article) {
        dropdownItemsClasses.push(s.article);
      }
    }
    return (
      <>
        {showSelectedOptionsList && this.renderSelectedOptionsList()}
        <div className={filterDropdownClasses.join(" ")}>
          {!article && (
            <div className={s.dropdownHeader} onClick={this.toggleOpen}>
              <h6 className={s.dropdownTitle}>{dropdownTitle}</h6>
              <img src={icon} className={s.chevronDown} alt="arrow down" />
            </div>
          )}
          <AnimateHeight height={open || hasSelected ? "auto" : 0}>
            {search && (
              <input
                value={searchTerm}
                onChange={e => this.setState({ searchTerm: e.target.value })}
                className={s.searchFilter}
                placeholder={`Search ${dropdownTitle.toLowerCase()}`}
              />
            )}
            <div className={dropdownItemsClasses.join(" ")}>
              {options
                ?.filter(o =>
                  searchTerm?.length > 2
                    ? o?.value?.toLowerCase()?.includes(searchTerm.toLowerCase())
                    : true
                )
                ?.map(this.renderOption)}
            </div>
            {expandable && !expanded && !!expandeableItems && (
              <div className={s.displayMoreItems}>
                <P small className={s.displayMoreItemsLabel} onClick={this.toggleExpand}>
                  {tx("misc.viewXMore", { number: expandeableItems })}
                </P>
              </div>
            )}
          </AnimateHeight>
        </div>
      </>
    );
  }
}
